import classNames from "classnames"
import { FC, HTMLProps, ReactNode } from "react"
import Row from "./Row"

export interface InputProps extends Omit<HTMLProps<HTMLInputElement>, "label" | "onChange" | "prefix"> {
  type?: "text" | "email" | "password" | "tel"
  onChange?(value: string): void
  prefix?: ReactNode
  prefixProps?: HTMLProps<HTMLSpanElement>
  suffix?: ReactNode
  suffixProps?: HTMLProps<HTMLSpanElement>
  label?: ReactNode
  labelProps?: HTMLProps<HTMLLabelElement>
  error?: ReactNode
  errorProps?: HTMLProps<HTMLDivElement>
}

const Input: FC<InputProps> = ({
  className,
  type = "text",
  suffix,
  suffixProps,
  prefix,
  prefixProps,
  label,
  labelProps,
  error,
  errorProps,
  onChange,
  ...props
}) => {
  return (
    <div className={className}>
      {label
        ?
        <label
          {...labelProps}
          className={classNames("input__label", labelProps?.className)}
        >{label}</label>
        : null
      }

      <Row className="input__wrapper">
        <input
          className={classNames("input", {
            ["input--suffix"]: !!suffix,
            ["input--prefix"]: !!prefix,
            ["input--error"]: !!error
          })}
          type={type}
          onChange={(e): void => onChange?.(e.target.value)}
          {...props}
        />

        {prefix
          ?
          <span
            {...prefixProps}
            className={classNames("input__prefix", prefixProps?.className)}
          >{prefix}</span>
          : null
        }

        {suffix
          ?
          <span
            {...suffixProps}
            className={classNames("input__suffix", suffixProps?.className)}
          >{suffix}</span>
          : null
        }
      </Row>

      {error
        ?
        <div
          {...errorProps}
          className={classNames("input__error", errorProps?.className)}
        >
          {error}
        </div>
        : null
      }
    </div>
  )
}

export default Input
